"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NONE = exports.HIGH = void 0;
var HIGH = 'HIGH';
exports.HIGH = HIGH;
var NONE = 'NONE';
exports.NONE = NONE;